import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class BlockUnblockOrganisationMutation extends Relay.Mutation {
    static propTypes = {
        organisation_id: PropTypes.string.isRequired,
        blocked: PropTypes.bool.isRequired,
        reason: PropTypes.string,
    };

    getMutation() {
        return Relay.QL`mutation { blockUnblockOrganisation }`;
    }

    getVariables() {
        return {
            organisation_id: this.props.organisation_id,
            blocked: this.props.blocked,
            reason: this.props.reason,
        };
    }

    getFatQuery() {
        return Relay.QL`
            fragment on BlockUnblockOrganisationPayload {
                clientMutationId,
                updatedNode {
                    id,
                    realId,
                    blocked,
                    blockedReason,
                    blockedAt,
                    isBillable,
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}

